import { noop } from "lodash";
import { protectedApiCallCallback } from "../api/network";
import { DiscoverySession } from "../stores/jotai/discovery-session";

export const markNotificationAsReadByIDs = (
    notificationIDs: string[],
    discoverySession: DiscoverySession,
    onDone: Function = noop
) => {
    if (notificationIDs.length > 0) {
        protectedApiCallCallback(
            discoverySession,
            "seen",
            {
                targets: notificationIDs,
                type: "notification",
            },
            {},
            () => {
                onDone();
            },
            "put"
        );
    }
};

export const markNotificationAsUnreadByIDs = (
    notificationIDs: string[],
    discoverySession: DiscoverySession,
    onDone: Function = noop
) => {
    if (notificationIDs.length > 0) {
        protectedApiCallCallback(
            discoverySession,
            "unseen",
            {
                targets: notificationIDs,
                type: "notification",
            },
            {},
            () => {
                onDone();
            },
            "put"
        );
        onDone();
    }
};
